import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { messages } from './messages/messages';

const LangProvider = ({ children }) => {
  const { currentLang } = useSelector((state) => state.lang);

  useEffect(() => {
    const fontClass = currentLang.locale === 'km-KH' ? 'khmer-font' : 'twcen-font';
    document.body.classList.remove('khmer-font', 'twcen-font');
    document.body.classList.add(fontClass);
  }, [currentLang.locale]);

  return (
    <IntlProvider locale={currentLang.locale} messages={messages[currentLang.locale]}>
      {children}
    </IntlProvider>
  );
};

export default LangProvider;
